function l(l){return l.eachNode!=null&&l.eachEdge!=null&&l.eachGroup!=null&&l.filter!=null}export{l as isFilterableDataset};
